/**
 * Copyright (c) 2010-2022 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { LoggerService } from '../../../../../modules/shared/services/logger.service';
import { ActivatedRoute } from '@angular/router';
import { Actions, ofActionSuccessful, Store } from '@ngxs/store';
import {
    ResetForgottenPassword,
    ResetPassword,
    ResetPasswordFailed,
    ResetPasswordSuccess,
} from '../../../state/auth.actions';
import { tap } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthState } from '../../../state/auth.state';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { ChangePasswordFormComponent } from '../forms/change-password-form/change-password-form.component';

@Component({
    selector: 'dash-gis-reset-password-dialog',
    templateUrl: './change-password-dialog.component.html',
    styleUrls: ['./change-password-dialog.component.scss'],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, ChangePasswordFormComponent],
})
export class ChangePasswordDialogComponent implements OnInit, OnDestroy {
    username: string;
    message = '';

    private dispose$ = new Subject<void>();

    constructor(
        private logger: LoggerService,
        private store: Store,
        private actions$: Actions,
        private route: ActivatedRoute,
        private snack: MatSnackBar,
        private dialogRef: MatDialogRef<ChangePasswordDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { [key: string]: any }
    ) {}

    ngOnInit(): void {
        this.username = this.store.selectSnapshot(AuthState.user)?.username;
        this.actions$
            .pipe(
                ofActionSuccessful(ResetPasswordSuccess),
                tap(() => this.snack.open('Your password has been successfully changed.', 'OK'))
            )
            .subscribe(() => this.dialogRef.close());

        this.actions$
            .pipe(
                ofActionSuccessful(ResetPasswordFailed),
                tap((action) => this.showMessage(action.message))
            )
            .subscribe();

        if (this.data?.message) {
            this.showMessage(this.data.message);
        }
    }

    ngOnDestroy(): void {
        this.dispose$.next();
    }

    changePassword(formValue) {
        this.message = '';
        this.store.dispatch(new ResetPassword(formValue));
    }

    close() {
        if (!this.data?.force) {
            this.dialogRef.close();
        }
    }

    showMessage(message: string) {
        this.message = message;
    }
}
